module.exports = "/_next/static/images/Connected@2x-6d97ddb084b2fa1c8e661ccab39dc0f2.webp";